import { useState } from "react";
import { toast } from "sonner";
import { Upload, CheckCircle2, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton, fmtMoney } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const yolla = (yol, dosya, cariId) => {
  const fd = new FormData(); fd.append("dosya", dosya); if (cariId) fd.append("cari_id", cariId);
  return api.post(yol, fd, { headers: { "Content-Type": "multipart/form-data" } });
};

const Ozet = ({ o }) => (
  <div className="space-y-3 text-sm" data-testid="kb-ekstre-ozet">
    <div><b>{o.unvan}</b> <span className="font-mono text-muted-foreground">{o.kod}</span></div>
    <div className={o.cari ? "text-emerald-300" : "text-amber-300"}>{o.cari ? `Mevcut cariye yazılacak: ${o.cari.unvan}` : "Bu kodla cari yok — yeni cari açılacak"}</div>
    <div>{o.satir} hareket · türler: {o.tipler.join(", ")}</div>
    <div className="rounded-lg border border-white/10 divide-y divide-white/10">{Object.entries(o.kontrol).map(([pb, k]) => (
      <div key={pb} className="flex items-center gap-2 px-3 py-2" data-testid={`kb-kontrol-${pb}`}>{k.tutuyor ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <AlertTriangle className="w-4 h-4 text-red-400" />}
        <b className="w-10">{pb}</b><span className="text-xs">Bizim düzenimizde: Borcumuz {fmtMoney(k.pdf.alacak, pb)} · Alacağımız {fmtMoney(k.pdf.borc, pb)} · Bakiye <b className={k.pdf.borc - k.pdf.alacak >= 0 ? "text-emerald-400" : "text-red-400"}>{fmtMoney(k.pdf.borc - k.pdf.alacak, pb)} {k.pdf.borc - k.pdf.alacak > 0.004 ? "alacaklıyız" : k.pdf.borc - k.pdf.alacak < -0.004 ? "borçluyuz" : ""}</b></span></div>))}</div>
    {o.urun.kalem > 0 && <div className="text-xs">Fatura kalemi: {o.urun.kalem} · stok kartına bağlanan: <b>{o.urun.eslesen}</b>{o.urun.eslesmeyen.length > 0 && <div className="text-muted-foreground mt-1">Eşleşmeyenler (Eşleştirilen Ürünler sekmesinden bağlayabilirsiniz): {o.urun.eslesmeyen.slice(0, 12).join(", ")}{o.urun.eslesmeyen.length > 12 ? "…" : ""}</div>}</div>}
    {o.mevcut_aktarim > 0 && <div className="text-amber-300 text-xs">Bu carinin daha önce aktarılmış {o.mevcut_aktarim} KolayBi satırı yeni ekstreyle değiştirilecek (elle girdiğiniz işlemler korunur).</div>}
  </div>
);

export const KolaybiEkstreDialog = ({ cariId, kapat, bitti }) => {
  const [dosya, setDosya] = useState(null);
  const [o, setO] = useState(null);
  const [busy, setBusy] = useState(false);
  const sec = async (f) => {
    setDosya(f); setO(null); setBusy(true);
    try { setO((await yolla("/kolaybi-ekstre/onizle", f, cariId)).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const aktar = async () => {
    setBusy(true);
    try { const { data } = await yolla("/kolaybi-ekstre/aktar", dosya, cariId); toast.success(`${data.eklenen} hareket aktarıldı`); bitti(data.cari); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const tamam = o && Object.values(o.kontrol).every((k) => k.tutuyor);
  return (
    <Dialog open onOpenChange={(v) => !v && kapat()}>
      <DialogContent className="glass max-w-xl" data-testid="kb-ekstre-dialog">
        <DialogHeader><DialogTitle className="font-head">KolayBi ekstresi yükle (PDF)</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">KolayBi'de cari sayfası → İşlemler → Cari Ekstresi Oluştur ile indirdiğiniz PDF'i seçin. Okunan toplamlar PDF'in altındaki toplamlarla karşılaştırılır; tutmazsa aktarılmaz. Geçmiş faturalar stok ve kasa/bankayı değiştirmez.</p>
        <label className={`flex items-center justify-center gap-2 h-20 rounded-xl border border-dashed border-white/20 hover:bg-white/5 cursor-pointer text-sm ${busy ? "opacity-50 pointer-events-none" : ""}`} data-testid="kb-ekstre-sec">
          <Upload className="w-5 h-5" />{dosya ? dosya.name : "PDF seçin"}
          <input type="file" accept="application/pdf" className="hidden" data-testid="kb-ekstre-dosya" onChange={(e) => { const f = e.target.files?.[0]; if (f) sec(f); e.target.value = ""; }} />
        </label>
        {busy && !o && <div className="text-sm text-muted-foreground">Okunuyor…</div>}
        {o && <Ozet o={o} />}
        <div className="flex justify-end gap-2"><button onClick={kapat} className="px-5 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5">Vazgeç</button>
          <GradButton data-testid="kb-ekstre-aktar" disabled={!tamam || busy} onClick={aktar}>{busy && o ? "Aktarılıyor…" : "Aktar"}</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};

export const KolaybiCekSenetButon = ({ yenile }) => {
  const [busy, setBusy] = useState(false);
  const yukle = async (f) => {
    setBusy(true);
    try { const { data } = await yolla("/kolaybi-cek-senet/aktar", f); toast.success(`${data.tur === "senet" ? "Senet" : "Çek"}: ${data.eklenen} eklendi, ${data.ciro_eslesen} ciro eşleşti, ${data.atlanan} zaten vardı`); yenile?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <label className={`inline-flex items-center gap-1.5 px-3 h-10 rounded-lg text-xs font-semibold border border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`} data-testid="kb-cek-yukle">
      <Upload className="w-4 h-4" />{busy ? "Aktarılıyor…" : "KolayBi Excel'i yükle"}
      <input type="file" accept=".xlsx" className="hidden" data-testid="kb-cek-dosya" onChange={(e) => { const f = e.target.files?.[0]; if (f) yukle(f); e.target.value = ""; }} />
    </label>
  );
};
